// extracted by mini-css-extract-plugin
export var createdDate = "_nx-1";
export var divider = "_nx-2";
export var headerDivider = "_nx-3";
export var messagesCard = "_nx-0";
export var messagesContainer = "_nx-7";
export var messagesContainerWrapper = "_nx-4";
export var pointerCapturingButtonBoxes = "_nx-a";
export var showLeftPanelButton = "_nx-9";
export var showMoreButton = "_nx-c";
export var showMoreButtonContainer = "_nx-b";
export var summaryTitle = "_nx-6";
export var systemMessageCardWrapper = "_nx-d";
export var topButtons = "_nx-8";
export var withPadding = "_nx-5";